import { fetchData } from "./fetchData";

export const getAllUsers = async () => {
  try {
    const route = `/users`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateUserRole = async (userID, role) => {
  try {
    const route = `/users/${userID}/role`;

    const options = {
      method: "PUT",
      Headers: {
        "Content-Type": "application/json",
      },
      body: { role },
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};
